(() => {
  const themeStorageKey = "readyfy-theme";
  const themeRoot = document.documentElement;
  const syncThemeButtons = () => {
    const light = themeRoot.dataset.theme !== "dark";
    document.querySelectorAll("[data-theme-toggle]").forEach((button) => {
      button.setAttribute("aria-label", `Switch to ${light ? "dark" : "light"} theme`);
      button.setAttribute("title", `${light ? "Dark" : "Light"} theme`);
      button.setAttribute("aria-pressed", String(!light));
    });
  };
  document.addEventListener("click", (event) => {
    if (!event.target.closest("[data-theme-toggle]")) return;
    const nextTheme = themeRoot.dataset.theme === "dark" ? "light" : "dark";
    themeRoot.dataset.theme = nextTheme;
    themeRoot.style.colorScheme = nextTheme;
    try { localStorage.setItem(themeStorageKey, nextTheme); } catch (error) {}
    syncThemeButtons();
  });
  syncThemeButtons();

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || "INR";
    const locale = window.Shopify?.locale || "en-IN";
    return new Intl.NumberFormat(locale, { style: "currency", currency, maximumFractionDigits: 0 }).format(cents / 100);
  };
  const escapeHtml = (value = "") => String(value).replace(/[&<>"']/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#039;",
  }[character]));
  const wishlistKey = "readyfy-wishlist";
  const readWishlist = () => {
    try {
      const saved = JSON.parse(localStorage.getItem(wishlistKey) || "[]");
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  };
  const writeWishlist = (items) => {
    try {
      localStorage.setItem(wishlistKey, JSON.stringify(items));
    } catch (error) {
      // Browsing can continue when storage is unavailable.
    }
  };
  const syncWishlistButtons = () => {
    const handles = new Set(readWishlist().map((item) => item.handle));
    document.querySelectorAll("[data-wishlist-add]").forEach((button) => {
      const saved = handles.has(button.dataset.productHandle);
      button.classList.toggle("is-saved", saved);
      button.setAttribute("aria-pressed", String(saved));
      if (button.classList.contains("product-wishlist-button")) {
        button.textContent = saved ? "♥ Saved to wishlist" : "♡ Save to wishlist";
      } else {
        button.textContent = saved ? "♥" : "♡";
      }
    });
  };
  const renderWishlist = () => {
    const grid = document.querySelector("[data-wishlist-grid]");
    if (!grid) return;
    const items = readWishlist();
    if (!items.length) {
      grid.innerHTML = '<p class="wishlist-empty">Your wishlist is empty. Save a kit while browsing the shop.</p>';
      return;
    }
    grid.innerHTML = items.map((item) => `
      <article class="wishlist-card">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ""}
        <div class="wishlist-card__body">
          <h2><a href="${escapeHtml(item.url)}">${escapeHtml(item.title)}</a></h2>
          <p>${money(Number(item.price))}</p>
          <div class="wishlist-card__actions">
            <button type="button" data-wishlist-cart="${Number(item.variantId)}">Add to cart</button>
            <button type="button" data-wishlist-remove="${escapeHtml(item.handle)}">Remove</button>
          </div>
        </div>
      </article>`).join("");
  };

  const menuButton = document.querySelector("[data-menu-toggle]");
  const mobileMenu = document.querySelector("[data-mobile-menu]");
  const desktopMenu = matchMedia("(min-width: 1025px)");
  const setMenu = (open) => {
    document.body.classList.toggle("menu-open", open);
    menuButton?.setAttribute("aria-expanded", String(open));
    mobileMenu?.setAttribute("aria-hidden", String(!desktopMenu.matches && !open));
  };
  menuButton?.addEventListener("click", () => setMenu(!document.body.classList.contains("menu-open")));
  mobileMenu?.addEventListener("click", (event) => {
    if (event.target.closest("a")) setMenu(false);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      setMenu(false);
      closeDrawer();
    }
  });
  desktopMenu.addEventListener?.("change", (event) => {
    if (event.matches) setMenu(false);
    else mobileMenu?.setAttribute("aria-hidden", "true");
  });
  mobileMenu?.setAttribute("aria-hidden", String(!desktopMenu.matches));

  const drawer = document.querySelector("[data-cart-drawer]");
  const drawerItems = drawer?.querySelector("[data-cart-items]");
  const openDrawer = () => {
    drawer?.classList.add("is-open");
    drawer?.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-open");
  };
  const closeDrawer = () => {
    drawer?.classList.remove("is-open");
    drawer?.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-open");
  };

  const renderCart = (cart) => {
    document.querySelectorAll("[data-cart-count]").forEach((el) => (el.textContent = cart.item_count));
    const count = drawer?.querySelector("[data-drawer-count]");
    const total = drawer?.querySelector("[data-cart-total]");
    if (count) count.textContent = cart.item_count;
    if (total) total.textContent = money(cart.total_price);
    if (!drawerItems) return;
    if (!cart.items.length) {
      drawerItems.innerHTML = '<p class="cart-empty">Your cart is ready for a fresh start.</p>';
      return;
    }
    drawerItems.innerHTML = cart.items.map((item) => `
      <article class="drawer-item" data-line-key="${item.key}">
        ${item.image ? `<img src="${item.image}" alt="${item.product_title.replace(/"/g, "&quot;")}">` : ""}
        <div><h3>${item.product_title}</h3><p>${item.variant_title || ""}</p><div class="drawer-qty"><button data-cart-change="${item.key}" data-quantity="${Math.max(0, item.quantity - 1)}">−</button><span>${item.quantity}</span><button data-cart-change="${item.key}" data-quantity="${item.quantity + 1}">+</button></div></div>
        <div><strong>${money(item.final_line_price)}</strong><button data-cart-change="${item.key}" data-quantity="0">Remove</button></div>
      </article>`).join("");
  };

  const getCart = () => fetch(`${window.Shopify.routes.root}cart.js`).then((r) => r.json());
  const refreshCart = async (shouldOpen = false) => {
    const cart = await getCart();
    renderCart(cart);
    if (shouldOpen) openDrawer();
    document.dispatchEvent(new CustomEvent("readyfy:cart:update", { detail: { cart } }));
  };

  document.addEventListener("click", async (event) => {
    const wishlistButton = event.target.closest("[data-wishlist-add]");
    if (wishlistButton) {
      const items = readWishlist();
      const handle = wishlistButton.dataset.productHandle;
      const existing = items.findIndex((item) => item.handle === handle);
      if (existing >= 0) items.splice(existing, 1);
      else items.push({
        handle,
        title: wishlistButton.dataset.productTitle,
        url: wishlistButton.dataset.productUrl,
        image: wishlistButton.dataset.productImage,
        price: Number(wishlistButton.dataset.productPrice),
        variantId: Number(wishlistButton.dataset.variantId),
      });
      writeWishlist(items);
      syncWishlistButtons();
      renderWishlist();
    }
    const wishlistRemove = event.target.closest("[data-wishlist-remove]");
    if (wishlistRemove) {
      writeWishlist(readWishlist().filter((item) => item.handle !== wishlistRemove.dataset.wishlistRemove));
      syncWishlistButtons();
      renderWishlist();
    }
    const wishlistCart = event.target.closest("[data-wishlist-cart]");
    if (wishlistCart) {
      wishlistCart.disabled = true;
      wishlistCart.textContent = "Adding…";
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(wishlistCart.dataset.wishlistCart), quantity: 1 }] }),
      });
      if (response.ok) await refreshCart(true);
      wishlistCart.textContent = response.ok ? "Added" : "Try again";
      wishlistCart.disabled = false;
    }
    if (event.target.closest("[data-cart-open]")) {
      event.preventDefault();
      await refreshCart(true);
    }
    if (event.target.closest("[data-cart-close]")) closeDrawer();
    const change = event.target.closest("[data-cart-change]");
    if (change) {
      change.disabled = true;
      const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: change.dataset.cartChange, quantity: Number(change.dataset.quantity) }),
      });
      renderCart(await response.json());
    }
    const thumb = event.target.closest("[data-product-thumb]");
    if (thumb) {
      document.querySelectorAll("[data-product-thumb]").forEach((el) => el.classList.remove("is-active"));
      thumb.classList.add("is-active");
      document.querySelectorAll("[data-product-media]").forEach((media) => {
        media.hidden = media.dataset.productMedia !== thumb.dataset.productThumb;
      });
    }
    const quantityButton = event.target.closest("[data-pdp-quantity]");
    if (quantityButton) {
      const counter = quantityButton.closest(".pdp-counter");
      const input = counter?.querySelector('input[name="quantity"]');
      if (input) input.value = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(quantityButton.dataset.pdpQuantity));
    }
    const productTab = event.target.closest("[data-pdp-tab]");
    if (productTab) {
      const tabs = productTab.closest(".pdp-tabs");
      tabs?.querySelectorAll("[data-pdp-tab]").forEach((button) => button.classList.toggle("is-active", button === productTab));
      tabs?.querySelectorAll("[data-pdp-panel]").forEach((panel) => {
        const active = panel.dataset.pdpPanel === productTab.dataset.pdpTab;
        panel.hidden = !active;
        panel.classList.toggle("is-active", active);
      });
    }
    const edit = event.target.closest("[data-address-edit]");
    if (edit) {
      const target = document.getElementById(edit.dataset.addressEdit);
      if (target) target.hidden = !target.hidden;
    }
  });

  document.querySelectorAll("[data-product-form]").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const button = form.querySelector('[type="submit"]');
      button.disabled = true;
      const original = button.textContent;
      button.textContent = "Adding…";
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: "POST",
          headers: { Accept: "application/json" },
          body: new FormData(form),
        });
        if (!response.ok) throw new Error("Unable to add product");
        await refreshCart(true);
        button.textContent = "Added";
      } catch (error) {
        button.textContent = "Try again";
      } finally {
        setTimeout(() => { button.disabled = false; button.textContent = original; }, 1000);
      }
    });

    const variantsData = form.querySelector("[data-product-json]");
    const select = form.querySelector("[data-variant-select]");
    if (variantsData && select) {
      const variants = JSON.parse(variantsData.textContent);
      form.querySelectorAll('input[name^="options"]').forEach((input) => {
        input.addEventListener("change", () => {
          const chosen = [...form.querySelectorAll('input[name^="options"]:checked')].map((el) => el.value);
          const variant = variants.find((item) => item.options.every((option, index) => option === chosen[index]));
          if (variant) {
            select.value = variant.id;
            const price = document.querySelector("[data-product-price]");
            if (price) price.textContent = money(variant.price);
            history.replaceState({}, "", `${location.pathname}?variant=${variant.id}`);
          }
        });
      });
    }
  });

  document.querySelectorAll("[data-product-recommendations]").forEach(async (container) => {
    if (container.innerHTML.trim()) return;
    const html = await fetch(container.dataset.url).then((r) => r.text());
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const replacement = parsed.querySelector("[data-product-recommendations]");
    if (replacement?.innerHTML.trim()) container.innerHTML = replacement.innerHTML;
  });

  const bundle = document.querySelector("[data-bundle-builder]");
  if (bundle) {
    const options = [...bundle.querySelectorAll("[data-bundle-option] input")];
    const button = bundle.querySelector("[data-bundle-add]");
    const updateBundle = () => {
      const selected = options.filter((input) => input.checked);
      const subtotal = selected.reduce((sum, input) => sum + Number(input.dataset.price), 0);
      const rate = selected.length >= 3 ? 0.2 : selected.length === 2 ? 0.15 : 0;
      bundle.querySelector("[data-bundle-count]").textContent = selected.length;
      bundle.querySelector("[data-bundle-subtotal]").textContent = money(subtotal);
      bundle.querySelector("[data-bundle-discount]").textContent = `−${money(Math.round(subtotal * rate))}`;
      bundle.querySelector("[data-bundle-total]").textContent = money(Math.round(subtotal * (1 - rate)));
      button.disabled = selected.length < 2;
    };
    options.forEach((input) => input.addEventListener("change", updateBundle));
    button.addEventListener("click", async () => {
      const items = options.filter((input) => input.checked).map((input) => ({ id: Number(input.value), quantity: 1 }));
      button.disabled = true;
      button.textContent = "Adding…";
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items }),
      });
      if (response.ok) await refreshCart(true);
      button.textContent = response.ok ? "Added to cart" : "Try again";
      setTimeout(() => { button.disabled = false; button.textContent = "Add bundle to cart"; }, 1200);
    });
    updateBundle();
  }

  document.querySelectorAll('select[name="address[country]"]').forEach((country) => {
    const province = country.closest("form")?.querySelector('select[name="address[province]"]');
    if (window.Shopify?.CountryProvinceSelector && country.id && province?.id) {
      new Shopify.CountryProvinceSelector(country.id, province.id, { hideElement: province.parentElement });
    }
  });
  syncWishlistButtons();
  renderWishlist();

  const faqRoot = document.querySelector("[data-readyfy-faq]");
  if (faqRoot) {
    const plusIcon = faqRoot.dataset.plusIcon;
    const minusIcon = faqRoot.dataset.minusIcon;
    const faqCards = [...faqRoot.querySelectorAll("[data-faq-item]")];
    const faqSearch = faqRoot.querySelector("[data-faq-search]");
    const faqEmpty = faqRoot.querySelector("[data-faq-empty]");
    const categoryButtons = [...faqRoot.querySelectorAll("[data-faq-category]")];
    const setFaqCard = (card, open) => {
      card.classList.toggle("is-open", open);
      const button = card.querySelector("[data-faq-toggle]");
      button.setAttribute("aria-expanded", String(open));
      button.querySelector("img").src = open ? minusIcon : plusIcon;
    };
    faqCards.forEach((card) => card.querySelector("[data-faq-toggle]").addEventListener("click", () => {
      const open = !card.classList.contains("is-open");
      faqCards.forEach((item) => setFaqCard(item, false));
      setFaqCard(card, open);
    }));
    faqSearch.addEventListener("input", () => {
      const term = faqSearch.value.trim().toLowerCase();
      let visible = 0;
      faqRoot.querySelectorAll("[data-faq-group]").forEach((group) => {
        let matches = 0;
        group.querySelectorAll("[data-faq-item]").forEach((card) => {
          const match = !term || card.textContent.toLowerCase().includes(term);
          card.hidden = !match;
          if (match) matches += 1;
        });
        group.hidden = matches === 0;
        if (group.classList.contains("faq-group--support")) group.style.display = term && matches ? "flex" : "";
        visible += matches;
      });
      faqEmpty.hidden = visible !== 0;
    });
    categoryButtons.forEach((button) => button.addEventListener("click", () => {
      categoryButtons.forEach((item) => item.classList.toggle("is-active", item === button));
      const group = document.getElementById(button.dataset.faqCategory);
      if (group) {
        group.style.display = "flex";
        group.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }));
  }

  const testimonialsRoot = document.querySelector("[data-readyfy-testimonials]");
  if (testimonialsRoot) {
    const stats = [...testimonialsRoot.querySelectorAll("[data-stat]")];
    const animateStats = () => {
      const start = performance.now();
      const duration = 1500;
      const draw = (now) => {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        stats.forEach((stat) => {
          const value = Number(stat.dataset.stat) * eased;
          const decimals = Number(stat.dataset.decimals || 0);
          const formatted = Number(stat.dataset.stat) >= 1000 ? Math.round(value).toLocaleString("en-IN") : value.toFixed(decimals);
          stat.textContent = `${formatted}${stat.dataset.suffix || ""}`;
        });
        if (progress < 1) requestAnimationFrame(draw);
      };
      requestAnimationFrame(draw);
    };
    const statsObserver = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      animateStats();
      statsObserver.disconnect();
    }, { threshold: .35 });
    statsObserver.observe(testimonialsRoot.querySelector(".testimonials-stats"));
  }

  const loader = document.querySelector("[data-site-loader]");
  if (loader) {
    document.body.prepend(loader);
    const seen = sessionStorage.getItem("readyfy-shopify-loader") === "true";
    if (seen) loader.remove();
    else {
      document.body.classList.add("loader-open");
      const finishLoader = () => {
        sessionStorage.setItem("readyfy-shopify-loader", "true");
        if (window.gsap) {
          gsap.timeline({
            onComplete: () => {
              document.body.classList.remove("loader-open");
              loader.remove();
            },
          })
            .to(loader.querySelector(".site-loader__content"), { scale: .72, opacity: 0, duration: .72, ease: "power4.inOut" })
            .to(loader, { opacity: 0, duration: .18, ease: "power1.out" }, "-=.12");
        } else {
          document.body.classList.remove("loader-open");
          loader.remove();
        }
      };
      if (window.gsap) gsap.to(loader.querySelectorAll(".site-loader__progress span"), { scaleX: 1, duration: 1.25, stagger: .08, ease: "power2.inOut" });
      setTimeout(finishLoader, 1450);
    }
  }

  window.addEventListener("load", () => {
    if (!window.gsap || !window.ScrollTrigger || matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    gsap.registerPlugin(ScrollTrigger);
    gsap.timeline({ repeat: -1, yoyo: true, defaults: { ease: "sine.inOut" } }).to(".hero-ambient", { xPercent: 1.35, yPercent: -.8, scale: 1.018, duration: 12 }).to(".hero-ambient", { xPercent: -.9, yPercent: 1.1, scale: 1.006, duration: 14 });
    gsap.from(".hero-core h1", { y: 35, opacity: 0, duration: .85, ease: "power3.out" });
    gsap.utils.toArray(".reveal").forEach((el) => gsap.from(el, { y: 28, opacity: 0, duration: .7, scrollTrigger: { trigger: el, start: "top 88%", once: true } }));
    const counters = [...document.querySelectorAll("[data-count]")];
    if (counters.length) ScrollTrigger.create({ trigger: ".stats", start: "top 88%", once: true, onEnter: () => counters.forEach((el, index) => { const state = { value: 0 }; gsap.to(state, { value: Number(el.dataset.count), duration: 1.6, delay: index * .1, ease: "power2.out", onUpdate: () => { el.textContent = `${state.value.toFixed(Number(el.dataset.decimals || 0))}${el.dataset.suffix || ""}`; } }); }) });
  });
})();
